import * as ratings from './ratings';
import * as submission from './submission';

exports.ratings = ratings;
exports.submission = submission;
